import { curriculumGateway } from '../curriculum-gateway';

import { Year } from '@types';

export const getYears = async (): Promise<Year[]> => {
    return curriculumGateway
        .get(`/years`, {
            withCredentials: true,
        })
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            throw new Error('Something went wrong loading the years.');
        });
};
